import api from './api';

export type StatusTreinamento = 'JaTeve' | 'Solicitado' | 'NaoPrecisa';

export const obterStatusTreinamentoPosVenda = () =>
    api.get<{ respondido: boolean }>('/Empresa/TreinamentoPosVenda');

export const responderTreinamentoPosVenda = (status: StatusTreinamento) =>
    api.post('/Empresa/TreinamentoPosVenda', { status });

export interface RastroPosVenda {
    reuniaoMarcada: boolean;
    reuniaoConcluida: boolean;
    posvendaFinalizado: boolean;
    posvendaDias: number | null;
}

export const obterRastroPosVenda = () =>
    api.get<RastroPosVenda>('/Empresa/RastroPosVenda');
